import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select", "info"]
  static values = { url: String }

  connect() {
    this.loadSiteInfo()
  }

  changed() {
    this.loadSiteInfo()
  }

  loadSiteInfo() {
    const siteId = this.selectTarget.value
    const infoWrapper = this.infoTarget.closest('.row')

    if (!siteId) {
      infoWrapper.style.display = 'none'
      return
    }

    infoWrapper.style.display = ''
    this.infoTarget.innerHTML = '<p class="text-grey">Loading site info...</p>'

    const returnTo = encodeURIComponent(window.location.pathname + window.location.search)
    fetch(`${this.urlValue}?assessment_site_id=${siteId}&return_to=${returnTo}`, {
      headers: { 'Accept': 'text/html' }
    })
      .then(response => response.text())
      .then(html => { this.infoTarget.innerHTML = html })
      .catch(() => {
        this.infoTarget.innerHTML = '<p class="text-grey">Could not load site info.</p>'
      })
  }
}
